// mj-view-switcher: loaded by MJ – Collection when the view switcher is on.
// Buttons [data-mj-grid] set 1–2 columns (mobile) or 2–4 columns (desktop); the choice is kept
// in localStorage and applied as html[data-mj-grid-m] / html[data-mj-grid-d].

const root = document.documentElement;

function currentValue(scope) {
  if (scope === 'm') return root.dataset.mjGridM || '2';
  return root.dataset.mjGridD || document.querySelector('[data-mj-default-grid-d]')?.dataset.mjDefaultGridD || '4';
}

function sync() {
  document.querySelectorAll('[data-mj-grid]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.mjGrid === currentValue(button.dataset.mjGridScope)));
  });
  // Keep card images sharp: tell the browser how wide cards now are
  const mobile = currentValue('m') === '1' ? '100vw' : '50vw';
  const desktop = Math.ceil(100 / Number(currentValue('d'))) + 'vw';
  document.querySelectorAll('.mj-collection__grid .mj-card__image').forEach((image) => {
    image.sizes = `(min-width: 990px) ${desktop}, (min-width: 750px) 33vw, ${mobile}`;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-mj-grid]');
  if (!button) return;
  const key = button.dataset.mjGridScope === 'm' ? 'mjGridM' : 'mjGridD';
  root.dataset[key] = button.dataset.mjGrid;
  try {
    localStorage.setItem(button.dataset.mjGridScope === 'm' ? 'mj-grid-m' : 'mj-grid-d', button.dataset.mjGrid);
  } catch (error) {}
  sync();
});

// The filter bar is re-rendered when filters change; keep the pressed state in step
new MutationObserver(() => {
  clearTimeout(window.mjViewSyncTimer);
  window.mjViewSyncTimer = setTimeout(sync, 50);
}).observe(document.querySelector('.mj-collection') || document.body, { childList: true, subtree: true });

sync();
